export default {
  app: {
    tradeOffers: {
      country: 'Land',
      loginPrompt: 'For at se rejsetilbud, skal du {0}.',
      logIn: 'log på',
    },
  },
};
